export var IdTutorialStep;
(function (IdTutorialStep) {
    IdTutorialStep["welcome_clickConfirmButton"] = "welcome_clickConfirmButton";
    IdTutorialStep["harvestCorn_clickAcre"] = "harvestCorn_clickAcre";
    IdTutorialStep["sowWildflowers_clickAcre"] = "sowWildflowers_clickAcre";
    IdTutorialStep["sowWildflowers_clickOnRecipe"] = "sowWildflowers_clickOnRecipe";
    IdTutorialStep["sowWildflowers_clickStartProduction"] = "sowWildflowers_clickStartProduction";
    IdTutorialStep["constructWindmill_clickBuildMenu"] = "constructWindmill_clickBuildMenu";
    IdTutorialStep["constructWindmill_clickBuyButton"] = "constructWindmill_clickBuyButton";
    IdTutorialStep["constructWindmill_confirmPlacement"] = "constructWindmill_confirmPlacement";
    IdTutorialStep["constructWindmill_constructionProgress"] = "constructWindmill_constructionProgress";
    IdTutorialStep["confirmConstruction"] = "confirmConstruction";
    IdTutorialStep["produceChickenFeed_clickWindmill"] = "produceChickenFeed_clickWindmill";
    IdTutorialStep["produceChickenFeed_clickStartProduction"] = "produceChickenFeed_clickStartProduction";
    IdTutorialStep["harvestWildflowers_clickAcre"] = "harvestWildflowers_clickAcre";
    IdTutorialStep["checkNewQuest_clickQuestMenu"] = "checkNewQuest_clickQuestMenu";
    IdTutorialStep["checkNewQuest_clickShowMeButton"] = "checkNewQuest_clickShowMeButton";
    IdTutorialStep["checkNewQuest_clickStartProduction"] = "checkNewQuest_clickStartProduction";
    IdTutorialStep["collectQuestReward_clickQuestMenu"] = "collectQuestReward_clickQuestMenu";
    IdTutorialStep["collectQuestReward_clickCollectRewards"] = "collectQuestReward_clickCollectRewards";
    IdTutorialStep["tutorialCompleteConfirmation"] = "tutorialEndConfirmation";
    IdTutorialStep["levelUpScreen"] = "levelUpScreen";
})(IdTutorialStep || (IdTutorialStep = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/IdTutorialStep.ts
// module id = 66
// module chunks = 3